/**
 * Body format for powerpoint_presentation exercises (stored in exercise.body as JSON).
 * @typedef {{ url: string, path?: string, fileName?: string }} PowerpointExerciseData
 */

/** @returns {PowerpointExerciseData | null} */
export function parsePowerpointBody(body) {
    if (!body || typeof body !== 'string') return null;
    const trimmed = body.trim();
    if (!trimmed) return null;
    try {
        const parsed = JSON.parse(trimmed);
        if (parsed && typeof parsed.url === 'string' && parsed.url.trim()) {
            return {
                url: parsed.url.trim(),
                path: parsed.path || undefined,
                fileName: parsed.fileName || undefined,
            };
        }
    } catch {
        // Legacy: raw URL string
        if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
            return { url: trimmed };
        }
    }
    return null;
}

/** @param {PowerpointExerciseData | null | undefined} data */
export function stringifyPowerpointBody(data) {
    if (!data?.url) return '';
    return JSON.stringify({
        url: data.url,
        ...(data.path ? { path: data.path } : {}),
        ...(data.fileName ? { fileName: data.fileName } : {}),
    });
}
